// ECRIT A LA MAIN, icone du fondateur (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/** Fleche droite PLEINE (fut + tete), d'un seul trace. Source `right.svg`. */
export const IconRight = createCustomIcon(
  'IconRight',
  '0 0 234.47 234.38',
  <polygon
    fill="currentColor"
    points="184.82 130.05 .05 129.89 0 104.28 184.77 104.2 98.99 18.3 117.29 0 234.47 117.2 117.3 234.38 98.91 216.2 184.82 130.05"
  />,
);
